(function () {
  angular
    .module("akitabox.ui.dialogs.externalQrScanner")
    .controller(
      "ExternalQrScannerDialogController",
      ExternalQrScannerDialogController
    );

  /* @ngInject */
  function ExternalQrScannerDialogController(
    // Angular
    $scope,
    $timeout,
    $window,
    $location,
    $element,
    // Material
    $mdDialog,
    // Services
    media,
    ShadowService,
    QRCodeService
  ) {
    var self = this;

    // Valid QR code regex
    var validQrCode =
      /^((http[s]?:)?\/\/)?((?:\w+\.)?((?:akitabox)|(?:\w+-abx)))\.com(:[0-9]*)?\/qrcode\/[a-zA-Z0-9]*/i;
    // Regex that matches API QR code image URL
    var qrCodeImageRegex = /^((http[s]?:)?\/\/)?(api\.).*(\/image)$/i;
    // Regex that matches parts of QR Code image URL
    var qrCodeImageUrlParts = /^((http[s]?:)?\/\/)|api\.|\/image/g;

    // Attributes
    self.scanned = false;
    self.loading = false;
    self.success = false;
    self.focusInput = false;

    // Functions
    self.cancel = cancel;
    self.parseUrl = parseUrl;
    self.reset = reset;

    init();

    // ------------------------
    //   Public Functions
    // ------------------------

    function parseUrl(url) {
      /**
       * Determine if url is a link to one of our QR code images instead of route
       *
       * Added for [WEBAPP-6754](https://akitabox.atlassian.net/browse/WEBAPP-6754)
       */
      var isImageUrl = qrCodeImageRegex.test(url);

      self.scanned = true;
      self.success = validQrCode.test(url);

      if (isImageUrl) {
        // Remove parts from URL that link to the image instead of route.
        // Normalizes incorrect image URL to expected QR code route format
        url = url.replace(qrCodeImageUrlParts, "");
      }

      if (self.success) {
        var qrCodeId = url.split("/").pop();
        self.loading = true;
        QRCodeService.getById(qrCodeId)
          .then(function (qrCode) {
            ShadowService.sendEvent("qr-code", "scan", "success");
            return $mdDialog.hide(qrCode);
          })
          .catch(function () {
            self.success = false;
            self.loading = false;
            ShadowService.sendEvent("qr-code", "scan", "fail");
          });
      } else {
        ShadowService.sendEvent("qr-code", "scan", "fail");
      }
    }

    function reset() {
      self.scanned = false;
      self.success = false;
      self.qrCodeUrl = null;
      init();
    }

    /**
     * Closes the dialog
     */
    function cancel() {
      ShadowService.sendEvent("qr-code", "cancel-scanner");
      $mdDialog.cancel();
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function init() {
      $timeout(function () {
        angular.element("#qrCodeInput").trigger("focus");
      }, 1000);
    }
  }
})();
